module.exports = __webpack_public_path__ + "static/media/logout-icon.24f37f5d.svg";